import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MessageModule } from 'primeng/message';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PanelModule } from 'primeng/panel';
import { EmailEditorComponent, EmailEditorModule } from 'angular-email-editor';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { EmailTemplateService } from 'src/app/private/services/email-template.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-create-email-template',
  imports: [SharedModule, MessageModule, PanelMenuModule, PanelModule, EmailEditorModule],
  templateUrl: './create-email-template.component.html',
  styleUrl: './create-email-template.component.scss'
})
export class CreateEmailTemplateComponent {

  @Output() closeDialog = new EventEmitter();
  @ViewChild(EmailEditorComponent)
  private emailEditor!: EmailEditorComponent;
  isSignatureDraging = false;

  @Input() type: any;
  @Input() templateDataToEdit: any;

  @Output() reload = new EventEmitter();

  pageTitle = 'Create';

  attachments: any[] = [];

  constructor(private api: EmailTemplateService, private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  isLoaded = false;
  formData = {
    templateName: '',
    templateCategory: '',
    status: ''
  };

  categories = [
    { label: 'Marketing', value: 'marketing' },
    { label: 'Notification', value: 'notification' },
    { label: 'Updates', value: 'updates' },
  ];

  statusOptions = [
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' }
  ];



  allLeadFeilds = [
    { key: 'Prefix', value: '{{prefix}}' },
    { key: 'Fist Name', value: '{{first_name}}' },
    { key: 'Last Name', value: '{{last_name}}' },
    { key: 'Email', value: '{{email}}' },
    { key: 'Phone', value: '{{phone}}' },
    { key: 'Source', value: '{{source}}' },

  ];

  editorLoadedFlag = false;

  signatures: any[] = [];

  btnLoading = false;

  htmlData = '';
  design: any = {};


  ngOnInit() {
    setTimeout(() => {
      this.isLoaded = true;

      if (this.type === 'edit') {
        this.pageTitle = 'Edit';
        this.formData.templateName = this.templateDataToEdit.template_name;
        this.formData.templateCategory = this.templateDataToEdit.template_category;
        this.formData.status = this.templateDataToEdit.status;
        this.htmlData = this.templateDataToEdit.template_body;
        
        // Load existing attachments
        if (this.templateDataToEdit.documents && Array.isArray(this.templateDataToEdit.documents)) {
          this.attachments = this.templateDataToEdit.documents.map((url: string) => ({
            url: url,
            name: this.getFileNameFromUrl(url),
            type: this.getFileTypeFromUrl(url),
            uploading: false
          }));
        }
      }

    }, 500);

    this.signatures = this.localStorage.getSignatures();

    // replace p with div
    this.signatures.forEach((signature: any) => {
      signature.signature = signature.signature.replace(/<p/g, '<div').replace(/<\/p>/g, '</div>');
    });

  }





  editorLoaded() {
    this.editorLoadedFlag = true;
  }

  editorReady() {
    setTimeout(() => {
      if (this.type === 'edit') {

        try {
          this.emailEditor.editor.loadDesign(
            JSON.parse(this.templateDataToEdit.template_design)
          );
        } catch (error) {
          console.error('Error loading design:', error);
        }
      }
    }, 500);
  }

  onDragStart(event: any, field: any) {
    console.log('Drag Started:', event);
    this.isSignatureDraging = true;
    event.dataTransfer?.setData('text', field);
  }

  onDragEnd(event: any) {
    this.isSignatureDraging = false;
    console.log('Drag Ended:', event);
  }

  onDragStart2(event: any, value: any) {
    this.isSignatureDraging = true;
    event.dataTransfer?.setData('text', value);
  }

  onDragEnd2(event: any) {
    this.isSignatureDraging = false;
    console.log('Signature Drag Ended:', event);
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    const field = event.dataTransfer?.getData('text'); // Retrieve the dragged field
    this.isSignatureDraging = false;
    if (field) {
      this.insertPlaceholder(field); // Call the method to insert the placeholder
    }
  }

  handleCloseDialog() {
    this.closeDialog.emit();
  }



  insertPlaceholder(field: string) {
    let placeholder = '';
    if (this.isSignatureDraging) {
      placeholder = `${field}`;
    } else {
      placeholder = `${field}`;
    }

    this.emailEditor.editor.exportHtml((data: any) => {
      const design = data.design;

      // Ensure the `rows` array exists in the design body
      if (!design.body.rows) {
        design.body.rows = [];
      }

      if (design.body.rows.length === 0) {
        // If no rows exist, add a new row
        const newRow = {
          id: `row_${Date.now()}`, // Generate a unique ID for the row
          cells: [1], // Define the cell count
          columns: [
            {
              id: `col_${Date.now()}`, // Generate a unique ID for the column
              contents: [
                {
                  type: 'text', // Text content type
                  values: {
                    text: `<span>${placeholder}</span>`, // The placeholder text wrapped in <p>
                  }
                }
              ],
              values: {
                backgroundColor: "",
                padding: "0px",
                border: {},
                borderRadius: "0px",
                _meta: {
                  htmlID: `u_column_${Date.now()}`, // Unique HTML ID
                  htmlClassNames: "u_column"
                }
              }
            }
          ],
          values: {
            displayCondition: null,
            columns: false,
            _styleGuide: null,
            backgroundColor: "",
            columnsBackgroundColor: "",
            backgroundImage: {
              url: "",
              fullWidth: true,
              repeat: "no-repeat",
              size: "custom",
              position: "center",
              customPosition: ["50%", "50%"]
            },
            padding: "0px",
            anchor: "",
            hideDesktop: false,
            _meta: {
              htmlID: `u_row_${Date.now()}`, // Unique HTML ID
              htmlClassNames: "u_row"
            },
            selectable: true,
            draggable: true,
            duplicatable: true,
            deletable: true,
            hideable: true
          }
        };

        // Append the new row to the rows array
        design.body.rows.push(newRow);
      } else {
        console.log('i am here');
        // If rows exist, append the placeholder to the last column in the first row
        const firstRow = design.body.rows[0];
        const lastColumn = firstRow.columns[firstRow.columns.length - 1]; // Get the last column

        console.log('firstRow:', firstRow);
        console.log('lastColumn:', lastColumn);

        if (lastColumn.contents && lastColumn.contents.length > 0) {
          // Append the placeholder to the `text` of the last content item in the last column
          const lastContent = lastColumn.contents[lastColumn.contents.length - 1];
          if (lastContent.type === 'text' && lastContent.values && lastContent.values.text) {
            // lastContent.values.text += `<span>${placeholder}</span>`; // Append the placeholder wrapped in <p>
            const currentText = lastContent.values.text.replace(/<\/?p>/g, ''); // Remove any existing <p> tags if present
            lastContent.values.text = `<p>${currentText}<span>${placeholder}</span></p>`; // Append the placeholder inside the <p> tag
          } else {
            // If the last content is not text, add a new text content with the placeholder
            lastColumn.contents.push({
              type: 'text',
              values: {
                text: `<span>${placeholder}</span>`
              }
            });
          }
        } else {
          // If the last column has no contents, initialize it with the placeholder
          lastColumn.contents = [
            {
              type: 'text',
              values: {
                text: `<span>${placeholder}</span>`
              }
            }
          ];
        }
      }


      console.log('Modified Design:', design);

      this.emailEditor.editor.loadDesign(
        JSON.parse(JSON.stringify(design ? design : ''))
      );
    });
  }

  copyToClipboard(value: any) {
    navigator.clipboard.writeText(`${value}`);
  }

  async exportHtml(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.emailEditor.editor.exportHtml((data: any) => {
        if (data && data.html) {
          console.log('Exported HTML:', data.design);
          this.htmlData = data.html;
          this.design = data.design;
          resolve(); // Resolve the promise once data is available
        } else {
          reject('Error exporting HTML');
        }
      });
    });
  }


  async handleSaveTemplate(form: any) {
    if (!form.valid) {
      // Mark all fields as touched to show validation errors
      Object.keys(form.controls).forEach(field => form.controls[field].markAsTouched({ onlySelf: true }));
      return;
    }

    try {
      this.btnLoading = true;
      await this.exportHtml();

      const commonPayload = {
        organization_id: this.localStorage.getOrganizationId(),
        template_body: this.htmlData,
        template_name: this.formData.templateName,
        template_category: this.formData.templateCategory,
        template_design: JSON.stringify(this.design),
        status: this.formData.status
      };

      const payload = this.type === 'edit'
        ? { ...commonPayload, template_id: this.templateDataToEdit.template_id }
        : commonPayload;

      const updatedPayload = this.addVariablesToPayload(payload);

      const apiCall = this.type === 'edit'
        ? this.api.updateTemplate(updatedPayload)
        : this.api.createTemplate(updatedPayload);

      apiCall.subscribe(
        (res: any) => {
          this.btnLoading = false;
          this.closeDialog.emit();
          this.messageService.add({ severity: 'success', summary: 'Success', detail: `Template ${this.type === 'edit' ? 'updated' : 'created'} successfully` });
          this.reload.emit()
        },
        (error: any) => {
          console.error('Error:', error);
          this.btnLoading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: `Error ${this.type === 'edit' ? 'updating' : 'creating'} template` });
        }
      );

    } catch (e) {
      console.error('Error:', e);
      this.btnLoading = false;
    }
  }

  addVariablesToPayload(payload: any) {
    const templateBody = payload.template_body;

    // Regex to match variables inside {{ }}
    const variableRegex = /{{(.*?)}}/g;

    // Extract variables and ensure uniqueness
    const variables = [...new Set([...templateBody.matchAll(variableRegex)].map(match => match[1].trim()))];

    // Add variables to the payload
    payload.variables = variables;
    
    // Add documents (attachment URLs)
    payload.documents = this.attachments.map(attachment => attachment.url);

    return payload;
  }

  onFileSelect(event: any) {
    const files = event.files;
    if (files && files.length > 0) {
      for (let file of files) {
        this.uploadFile(file);
      }
    }
  }

  uploadFile(file: File) {
    // Add attachment with uploading state
    const attachment = {
      name: file.name,
      type: this.getFileType(file.name),
      uploading: true,
      url: ''
    };
    this.attachments.push(attachment);
    const attachmentIndex = this.attachments.length - 1;

    this.api.uploadFileToS3(file).subscribe(
      (response: any) => {
        if (response && response.url) {
          this.attachments[attachmentIndex].url = response.url;
          this.attachments[attachmentIndex].uploading = false;
          this.messageService.add({ 
            severity: 'success', 
            summary: 'Success', 
            detail: 'File uploaded successfully' 
          });
        }
      },
      (error: any) => {
        console.error('Upload error:', error);
        this.attachments.splice(attachmentIndex, 1);
        this.messageService.add({ 
          severity: 'error', 
          summary: 'Error', 
          detail: 'Failed to upload file' 
        });
      }
    );
  }

  removeAttachment(index: number) {
    this.attachments.splice(index, 1);
  }

  getFileType(fileName: string): string {
    const ext = fileName.split('.').pop()?.toLowerCase();
    if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext || '')) return 'image';
    if (['mp4', 'avi', 'mov', 'wmv'].includes(ext || '')) return 'video';
    if (['pdf', 'doc', 'docx', 'xls', 'xlsx', 'txt'].includes(ext || '')) return 'document';
    return 'document';
  }

  getFileTypeFromUrl(url: string): string {
    const fileName = url.split('/').pop() || '';
    return this.getFileType(fileName);
  }

  getFileNameFromUrl(url: string): string {
    return url.split('/').pop() || 'File';
  }

  getFileIcon(type: string): string {
    switch(type) {
      case 'image': return 'pi-image';
      case 'video': return 'pi-video';
      case 'document': return 'pi-file';
      default: return 'pi-file';
    }
  }

}

